import { render } from "./FormCommun.vue?vue&type=template&id=2a99e4f6"
import script from "./FormCommun.vue?vue&type=script&lang=js"
export * from "./FormCommun.vue?vue&type=script&lang=js"

import "./FormCommun.vue?vue&type=style&index=0&id=2a99e4f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__